<sui-progress *ngIf="visible" class="top attached blue active top-fixed" [value]="progress"
  [autoSuccess]="false">
</sui-progress>
